import React, { useEffect, useState } from "react";
import TextfieldNumber from "../textfields/textfield.number";
import TextfieldAbattement from "../textfields/textfield.abattement";
import { styles } from "../../stylesheets/simulateurs.css";
import "../../stylesheets/simulateursBis.css";
import SelectCommon from "../selects/select.common";
import ButtonYesno from "../buttons/button.yesno.js";
import { useDispatch } from "react-redux";
import { setDMTGObject } from "../../actions/dmtg.action";
import { ToolTipPerso } from "../selects/tooltip_perso";
import {DesktopDatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import moment from "moment";
import {useSnackbar} from "notistack";
import axios from "axios";
import {API_BASE_URL} from "../../config";

const Donations_immo = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  // Ici props contient donc :
  // props.resultKey => key du tableau "results" nécessaire pour setter la bonne valeur
  // props.functionSetResults => pour lancer la fonction du main depuis le component
  // ----

  // States avec les différentes valeurs à stocker
  // Possibilité également de mettre tous les states (value1, value2....) dans un seul state sous format:
  //
  // state: {
  //      value1: {},
  //      value2: {},
  //      ...
  // }
  //
  // Dans ce cas penser à changer le callback du useEffect qui prend plus bas [value1, value2]
  // ---

  const [lienParente, setLien] = useState(7);
  //const [nomDonataire, setNomDonataire] = useState(0)
  const [handicap, setHandicap] = useState(0);
  const [montantDonation, setMontantDonation] = useState(0);
  const [abattementLegal, setAbattementLegal] = useState(0);
  const [montantUtilise, setMontantUtilise] = useState(0);
  const [abattementReconstitue, setAbattementReconstitue] = useState(0);
  const [dateDonation, setDateDonation] = useState(new Date());
  const [donationsAnterieures, setDonationsAnterieures] = useState(0);
  const [donationsData, setDonationsData] = useState([{}]);
  let rappelFiscal;
  const [abattements, setAbattements] = useState([]);   // ex-back: [{cas, abattement_legal, taux_tranche}, ...]
  const BONUS_HANDICAP = 159_325;
  const formatNumber = (n) => new Intl.NumberFormat("fr-FR").format(Number(n || 0));
  const isDroitsReglesEnabled = (donations = donationsData) => {
    const abattementUtilise = donations.reduce((sum, donation) => sum + (Number(donation.montant) || 0), 0);
    return abattementUtilise < Number(abattementLegal || 0);
  };
  const isAbattementReconstitueEnabled = (donations = donationsData) =>
    donations.some((donation) => Number(donation.montant || 0) > 0) && !isDroitsReglesEnabled(donations);
  const formatDonationsData = (donations = donationsData) =>
      donations.map(({ montant, date, droits_regles }) => ({
        montant: parseFloat(montant),
        date,
        droits_regles: isDroitsReglesEnabled(donations) ? parseFloat(droits_regles || 0) : 0,
      }));

  const handleChange = async (setter, value) => {
    if(setter === setDateDonation && donationsData.length > 0 && donationsData[0]['date']) {
      if(value < donationsData[0]['date']) {
        enqueueSnackbar("La date doit être postérieure à celle de la donation antèrieure", {
          variant: "error",
        });
        return;
      }
      rappelFiscal = new Date(value);
      rappelFiscal.setFullYear(rappelFiscal.getFullYear() - 15);
      if(donationsData[donationsData.length - 1]['date']) {
        if(donationsData[donationsData.length - 1]['date'] < parseInt(moment(rappelFiscal.toString()).utc(true).format("x"))) {
          enqueueSnackbar("Vous aurez une ou plusieurs donations antérieures en dehors du rappel fiscal, merci de vérifier les données renseignées", {
            variant: "error",
          });
          return;
        }
      } else {
        if(donationsData[donationsData.length - 2]['date'] < parseInt(moment(rappelFiscal.toString()).utc(true).format("x"))) {
          enqueueSnackbar("Vous aurez une ou plusieurs donations antérieures en dehors du rappel fiscal, merci de vérifier les données renseignées", {
            variant: "error"
          });
          return;
        }
      }
    }
    if (setter === setMontantUtilise) {
      value = Math.max(Math.min(parseInt(value) || 0, abattementLegal) - (parseInt(abattementReconstitue) || 0), 0);
    }
    if (setter === setAbattementReconstitue) {
      if (parseInt(value) >= (parseInt(abattementLegal) || 0)) {
        enqueueSnackbar("Le montant de l'abattement reconstitué ne peut pas dépasser le montant de l'abattement légal", { 
          variant: 'warning' 
        });
      }
      value = Math.min((parseInt(value) || 0), (parseInt(abattementLegal) || 0))
    }
    if (setter === setLien) {
      const cas_instead_of_value = parseInt(value) - 6
      setter(cas_instead_of_value);
      setInRedux(setter, cas_instead_of_value);
    } else {
      setter(value);
      setInRedux(setter, value);
    }
  };

  const handleDonationChange = async (index, key, value) => {
    if(key === 'date') {
      rappelFiscal = new Date(dateDonation);
      rappelFiscal.setFullYear(rappelFiscal.getFullYear() - 15);
      if(index === 0) {
        if(value > dateDonation) {
          enqueueSnackbar("La date doit être antèrieure à celle de la nouvelle donation", {
            variant: "error",
          });
          return;
        }
      } else {
        if(value > donationsData[index - 1]['date']) {
          enqueueSnackbar("La date doit être antèrieure à celle de la donation précédente", {
            variant: "error",
          });
          return;
        }
      }
      if(value < parseInt(moment(rappelFiscal.toString()).utc(true).format("x"))) {
        enqueueSnackbar("La date est en dehors du rappel fiscal", {
          variant: "error",
        });
        return;
      }
    }
    if (key === "montant") {
      value = parseFloat(value);
    }
    if (key === "droits_regles") {
      value = parseFloat(value);
    }
    const updatedDonations = [...donationsData];
    updatedDonations[index][key] = value;
    setDonationsData(updatedDonations);
    setInRedux(setDonationsData, updatedDonations);
  };

  const addDonation = () => {
    if (!donationsData[donationsData.length - 1]['date'] || !donationsData[donationsData.length - 1]['montant']) {
      enqueueSnackbar("Merci de remplir les informations de la donation antèrieure avant d'en rajouter une autre", {
        variant: "error",
      });
      return;
    }
    const updatedDonations = [...donationsData, {}];
    setDonationsData(updatedDonations);
  };

  const removeDonation = () => {
    if (donationsData.length > 1){
      const updatedDonations = [...donationsData];
      updatedDonations.pop();
      setDonationsData(updatedDonations);
      setInRedux(setDonationsData, updatedDonations);
    }
  };

  function setInRedux(setter, value) {
    let object = {
      simulateurid: props.simulateurid,
      inputs: {
        lien_parente_donation: parseInt(lienParente),
        handicap: parseInt(handicap),
        montant_donation: parseInt(montantDonation),
        montant_utilise: parseInt(montantUtilise),
        abattement_reconstitue: parseInt(abattementReconstitue),
        donateur: parseInt(props.donateur),
        donataire: parseInt(props.soloResultKey + 1),
      },
      donations_anterieures: donationsData.map(({ montant, date, droits_regles}) => ({
        montant: parseFloat(montant),
        date: Date.parse(date),
        droits_regles: parseFloat(droits_regles || 0)
      }))
    };

    if (dateDonation !== undefined && dateDonation !== null) {
      Object.assign(object['inputs'], {
        date_nouvelle_donation: parseInt(moment(dateDonation.toString()).utc(true).format("x"))
      });
    }

    if (setter === setLien) { Object.assign(object["inputs"], { lien_parente_donation: parseInt(value) }); }
    if (setter === setHandicap) { Object.assign(object["inputs"], { handicap: parseInt(value) }); }
    if (setter === setDateDonation) {
      if (value !== undefined && dateDonation !== null) {
        Object.assign(object['inputs'], {date_nouvelle_donation: parseInt(moment(value.toString()).utc(true).format("x"))})
      }
    }
    if (setter === setMontantDonation) { Object.assign(object["inputs"], { montant_donation: parseInt(value) }); }
    if (setter === setMontantUtilise) { Object.assign(object["inputs"], { montant_utilise: parseInt(value) }); }
    if (setter === setAbattementReconstitue) { Object.assign(object["inputs"], { abattement_reconstitue: parseInt(value) }); }
    if (setter === setDonationsAnterieures) {
      if (value === 0) {
        setDonationsData([{}])
        object.donations_anterieures = [{}];
        setAbattementReconstitue(0);
        setMontantUtilise(0);
        Object.assign(object["inputs"], { montant_utilise: 0 });
      } else {
        object.donations_anterieures = formatDonationsData(donationsData);
        handleDonationChange(0, "date", Date.parse(dateDonation));
      }
    }
    if (setter === setDonationsData) { object.donations_anterieures = formatDonationsData(value); }

/*          if (setter === setNomDonataire) {
                props.functionSetDonatairesList(props.soloResultKey, {"nom": value})
            }*/
    props.functionSetSoloResults(props.soloResultKey, object);
    dispatch(setDMTGObject(object));
  }

  

  useEffect(() => {
    const controller = new AbortController();
    const token = JSON.parse(localStorage.getItem("user"))?.jwt;

    axios.get(`${API_BASE_URL}/abattement_DMTG`, {
      signal: controller.signal,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
    .then((res) => {
      // normalise
      const rows = (res.data ?? []).map(r => ({
        id: Number(r.id),
        cas: Number(r.cas),
        description: String(r.description),
        abattement_legal: Number(r.abattement_legal),
      }));
      // ne garde que les donations: id 7..14
      const onlyDonations = rows.filter(r => r.id >= 7 && r.id <= 14);

      setAbattements(onlyDonations);

      if (onlyDonations.length > 0) {
        const firstCas = onlyDonations[0].cas;
        setLien(firstCas);
        setInRedux(setLien, firstCas);
      }
    })
    .catch((err) => {
      console.error("GET /abattement_DMTG failed:", err?.response?.status, err?.response?.data);
      enqueueSnackbar("Erreur chargement abattements", { variant: "error" });
    });

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (!lienParente) return;

    const selected = abattements.find(r => r.cas === Number(lienParente));
    if (!selected) return;

    let value = selected.abattement_legal;
    if (Number(handicap) === 1) value += BONUS_HANDICAP;

    setAbattementLegal(value);
  }, [lienParente, handicap, abattements]);

  useEffect(() => {
    if (donationsData && donationsData.length > 0) {
      const newAbattementUtilise = donationsData.reduce((sum, donation) => {
        return sum + (donation.montant || 0);
      }, 0);
      handleChange(setMontantUtilise, newAbattementUtilise);
    }
  }, [donationsData, abattementLegal, abattementReconstitue]);

  return (
    <div style={styles.cardFlexContainer}>
      {/*<div>
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>
                            Indiquer le nom du donataire
                        </div>
                        <TextfieldNumber
                            handleChange={handleChange}
                            type={"text"}
                            placeholder={"Indiquer le nom"}
                            setter={setNomDonataire}
                        />
                    </div>
                </div>*/}

      <div style={styles.cardTitleDonataire}>Donataire {props.soloResultKey + 1}</div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Quel est leur lien de parenté ?</div>
        {abattements.length > 0 && (
        <SelectCommon
          items={abattements}
          nameField="description"
          optionValue="id"
          defaultValue={lienParente || abattements[0].id}
          handleChange={handleChange}
          setter={setLien}
        />
        )}
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Le bénéficiaire est-il en situation de handicap ?
          <ToolTipPerso title={"En cas d’invalidité permanente, abattement de 159 325 € cumulable."} />
        </div>
        <ButtonYesno handleChange={handleChange} setter={setHandicap} defaultValue={0} />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Indiquer la date de la donation
        </div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
              inputFormat="DD/MM/YYYY"
              value={dateDonation}
              onChange={((val) => {
                handleChange(setDateDonation, val)
              })}
              renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Montant de la donation lui revenant
          <ToolTipPerso
            title={
              "S'il s'agit d'une donation avec réserve d'usufruit, merci d'indiquer la part donnée en nue-propriété selon l'article 669 du CGI."
            }
          />
        </div>
        <TextfieldNumber
          handleChange={handleChange}
          type={"number"}
          placeholder={"Indiquer le montant"}
          setter={setMontantDonation}
        />
      </div>

      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Abattement légal</div>
        <TextfieldAbattement type={"number"} placeholder={`${formatNumber(abattementLegal)} €`} />
      </div>

      {/*DONATIONS ANTERIEURES*/}
      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>
          Le bénéficiaire a-t-il déjà reçu une donation au cours des 15 dernières années ?
          <ToolTipPerso title={"De la part du même donateur et dans le délai de rappel fiscal des donations antérieures qui est de 15 ans."} />
        </div>
        <ButtonYesno handleChange={handleChange} setter={setDonationsAnterieures} defaultValue={0} />
      </div>

      {donationsAnterieures ? (
          <div>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Part de l’abattement légal déjà utilisé au cours des 15 dernières années
                <ToolTipPerso title={"Dans le délai de rappel fiscal des donations antérieures qui est de 15 ans."} />
              </div>
              <TextfieldAbattement
                  type={"number"}
                  placeholder={montantUtilise.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €"}
              />
            </div>
            {donationsData.map((donation, index) => (
                <div key={index}>

                  <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>Indiquer la date de la donation antérieure {index +1}</div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDatePicker
                          inputFormat="DD/MM/YYYY"
                          value={donation.date}
                          onChange={(e) => {
                            void handleDonationChange(index, 'date', parseInt(moment(e.toString()).utc(true).format("x")))
                          }}
                          renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>Montant de la donation antérieure {index +1}</div>
                    <TextfieldNumber
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        handleChange={handleDonationChange}
                        index={index}
                        keyName={"montant"}
                    />
                  </div>
                  {isDroitsReglesEnabled() ? (
                    <div className="cardRow">
                      <div style={styles.cardElemVerticalyCenter}>
                        Indiquer le montant des droits réglés pour la donation antérieure {index +1}
                        <ToolTipPerso title={"Montant des droits de donation déjà payés pour cette donation antérieure"} />
                      </div>
                      <TextfieldNumber
                          type={"number"}
                          placeholder={"Indiquer le montant"}
                          handleChange={handleDonationChange}
                          index={index}
                          keyName={"droits_regles"}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
            ))}
            {isAbattementReconstitueEnabled() ? (
              <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                  Abattement reconstitué dans le rappel fiscal
                  <ToolTipPerso title={"Dans le délai de rappel fiscal des donations antérieures qui est de 15 ans."} />
                </div>
                <TextfieldNumber type={"number"} placeholder={"Indiquer le montant"} handleChange={handleChange} setter={setAbattementReconstitue} max={abattementLegal} />
              </div>
            ) : null}
            <div>
              <div style={styles.buttonsArea}>
                <button style={styles.removeButton} type="button" onClick={() => removeDonation()}>Supprimer donation</button>
                <button style={styles.addButton} type="button" onClick={addDonation}>Ajouter donation</button>
              </div>
            </div>
          </div>
      ) : (
          <></>
      )}

    </div>
  );
};
export default Donations_immo;
